﻿import 'owl.carousel';

(function ($) {
	"use strict";
	var cdnvalue = $("#cdnInput").data("value");
	var mapservice;
	var defaultPosition;// = { lat: -22.970722, lng: -43.182365 };
	var dealerName;
	var mapContainer = $('.dealer-details-maps');
	const isHidden = () => mapContainer.hasClass('dealer-details-maps--hidden');
	let locationMarker;
	let currentLocationMarker = '' + cdnvalue + '/dist/images/maps/my-location.svg';
	let geoCoder = new google.maps.Geocoder();

	function init() {
		$("body").addClass("grey-background");
		if (isHidden()) {
			$('.dealer-details-cards').removeClass('u-margin-top');
		}
		if (mapContainer.length) {
			setTimeout(function () {
				initMap();
			}, 3000);
			initCarousel();
		}
		locationMarker = new google.maps.Marker({
			anchorPoint: new google.maps.Point(0, -29),
			icon: currentLocationMarker
		});
		useGeoLocation();
	}

	function initMap() {
		var lat = mapContainer.data("lat");
		var lng = mapContainer.data("lng");
		defaultPosition = { lat: lat, lng: lng };
		dealerName = mapContainer.data('dealername');

		if (!isHidden()) {
			var map = new google.maps.Map(document.getElementById("map"), {
				center: defaultPosition,
				zoom: 16,
				minZoom: 5,
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: true,
				streetViewControl: true,
				rotateControl: true,
				fullscreenControl: false,
				zoomControlOptions: {
					position: google.maps.ControlPosition.RIGHT_TOP
				},
				streetViewControlOptions: {
					position: google.maps.ControlPosition.RIGHT_TOP
				},

				styles: shvenergy.maputils.mapStyles
			});

			mapservice = new google.maps.places.PlacesService(map);

			var marker = new google.maps.Marker({
				position: defaultPosition,
				icon: "" + cdnvalue + "/dist/images/maps/cylinder.png",
				map: map,
				title: 'Hello World!'
			});
		} else {
			mapservice = new google.maps.places.PlacesService(document.createElement('div'));
		}

		getPlaceId();
	}

	function getPlaceId() {
		mapservice.nearbySearch({
			location: defaultPosition,
			radius: 500,
			keyword: dealerName

		}, function (results, status) {
			if (status === google.maps.places.PlacesServiceStatus.OK) {
				if (results && results.length) {
					getOpeningHours(results[0].place_id);
				}
			}
			else {
				if ($(".opening-hours__card").find('.opening-hours__card__holidays').length > 0) {
					$(".opening-hours__card").find('.opening-hours').remove();
					$(".opening-hours__card").addClass('show');
				} else {
					$(".opening-hours__card").closest('div.columns').remove();
				}

			}
		});
	}

	function getOpeningHours(placeId) {
		mapservice.getDetails({
			placeId: placeId,
			fields: ['opening_hours']
		}, function (place, status) {
			if (status === google.maps.places.PlacesServiceStatus.OK) {
				if (place.opening_hours) {
					setOpeningHours(place.opening_hours)
				}
				else {
					if ($(".opening-hours__card").find('.opening-hours__card__holidays').length > 0) {
						$(".opening-hours__card").find('.opening-hours').remove();
						$(".opening-hours__card").addClass('show');
					} else {
						$(".opening-hours__card").closest('div.columns').remove();
					}
				}
			}
		});
	}

	function setOpeningHours(data) {
		if (data.weekday_text && data.weekday_text.length) {

			//var table = $("<table><tbody></tbody></table>")
			var table = $("<ul class='opening-hours__date-list u-margin-top u-margin-bottom'></ul>")

			const openingHoursElems = data.weekday_text.map(weekdayText => {
				var arr = [];             //new storage
				var row = $("<li/>");

				var str = weekdayText.split(' ');     //split by spaces
				arr.push(str.shift());    //add the number
				arr.push(str.join(' '));  //and the rest of the string	

				var weekdayNameSpan = $("<span>", {
					"text": arr[0],
					"class": "weekday-name-label"
				});

				weekdayNameSpan.appendTo(row);

				try {
					var openingHoursSpan = $("<span>", {
						"text": arr[1]
					});
					openingHoursSpan.appendTo(row);
				} catch (error) { }
				return row;
			});
			table.append(...openingHoursElems);
			table.appendTo($(".opening-hours__card .opening-hours"));
			setTimeout(function () {
				$(".opening-hours__card").addClass('show');
			}, 500);
		}
	}


	function initCarousel() {

		$('.js-related-products-carousel').owlCarousel({
			stagePadding: 0,
			loop: false,
			margin: 16,
			nav: true,
			navText: [
				'<svg focusable="false" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32"><use xlink:href="' + cdnvalue + '/dist/svgsprite/icons.svg#Arrow_No-stem_32x32"></use></svg>',
				'<svg focusable="false" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32"><use xlink:href="' + cdnvalue + '/dist/svgsprite/icons.svg#Arrow_No-stem_32x32"></use></svg>'
			],
			responsive: {
				0: {
					items: 2
				},
				480: {
					items: 3
				},
				960: {
					items: 4,
					stagePadding: 0
				}
			}
		});


		//let swiper1 = new Swiper('.js-swiper-1', {
		//	// Default parameters
		//	slidesPerView: 4,
		//	spaceBetween: 40,
		//	// Responsive breakpoints
		//	breakpoints: {
		//		// when window width is <= 480px
		//		480: {
		//			slidesPerView: 2,
		//			spaceBetween: 20
		//		},
		//		960: {
		//			slidesPerView: 3,
		//			spaceBetween: 20
		//		}
		//	},
		//	pagination: {
		//		el: '.swiper-pagination',
		//		clickable: true
		//	},
		//	//scrollbar: {
		//	//	el: '.swiper-scrollbar',
		//	//	draggable: true,
		//	//},
		//	navigation: {
		//		nextEl: '.swiper-button-next',
		//		prevEl: '.swiper-button-prev'
		//	}
		//});
	}
	
	function useGeoLocation() {
		// Try HTML5 geolocation.
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				successCallback
			);

			function successCallback(position) {
				let latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
				geoCoder.geocode({ 'latLng': latLng }, function (results, status) {
					if (status === google.maps.GeocoderStatus.OK && results[0]) {
						locationMarker.setPosition(latLng);
						var markerLocation = getDefaultMarkerLocation();
						setGetDirectionsButtons(markerLocation);		
					}
				});
			}
		}
	}

	function getDefaultMarkerLocation() {
		if (locationMarker) {
			var v = locationMarker.getVisible();
			if (v) {
				return locationMarker.getPosition();
			}
			return null;
		}
		return null;
	}

	function setGetDirectionsButtons(location) {
		let loc = location.lat() + "," + location.lng();
		let dealerDirection = $(".get-dealer-direction");
		let addressDirection = $(".address_button.links_anchor");
		
		if (dealerDirection) {
			let replacedHref = dealerDirection.attr("href").replace("dir//", 'dir/' + loc + '/');
			dealerDirection.attr("href", replacedHref);
		}
		if (addressDirection) {
			let replacedAddressHref = addressDirection.attr("href").replace("dir//", 'dir/' + loc + '/');
			addressDirection.attr("href", replacedAddressHref);
		}
	}

	$(function () {
		init();
	});
})(jQuery);






